import RenderAvatar from "./RenderAvatar";

export default RenderAvatar;
